import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import Button from "./CustomButton";
import { connect } from "react-redux";
import Icon from "@fortawesome/react-fontawesome";
import { actions } from "../modules/shoppingCart";
import fp from "lodash/fp";
import { Input, FormGroup, Label } from "reactstrap";
import AddToCartSuccessAdvice from "../containers/AddToCartSuccessAdvice";
import WithFetchShoppingCart from "../containers/WithFetchShoppingCart";

const AddProductToCartButton = ({
  role,
  productId,
  dealerId,
  variantId,
  customerId,
  createShoppingCart,
  updateShoppingCart,
  shoppingCart
}) => {
  const [quantity, setQuantity] = useState(1);
  const onChangeQuantity = useCallback(
    ev => {
      setQuantity(parseInt(ev.target.value, 10));
    },
    [setQuantity]
  );
  const onClick = useCallback(() => {
    const item = {
      product_id: productId,
      quantity
    };
    if (variantId) {
      item.variant_id = variantId;
    }
    if (!shoppingCart) {
      const data = {
        shopping_cart: {
          purchased_products_attributes: [item]
        }
      };
      createShoppingCart({ dealerId, customerId, data });
    } else {
      const existingProduct = fp.pipe(
        fp.getOr([], "purchased_products"),
        fp.find(pp => pp.product_id === productId)
      )(shoppingCart);
      if (existingProduct) {
        item.id = existingProduct.id;
        item.quantity += existingProduct.quantity;
      }
      const data = {
        shopping_cart: {
          purchased_products_attributes: [
            ...fp.reject(
              pp => pp.productId === productId,
              shoppingCart.purchased_products_attributes
            ),
            item
          ]
        }
      };
      updateShoppingCart({ dealerId, customerId, data });
    }
  }, [
    productId,
    quantity,
    variantId,
    shoppingCart,
    createShoppingCart,
    dealerId,
    customerId,
    updateShoppingCart
  ]);
  if (role === "customer" || role === "anonymous") {
    return (
      <div>
        <FormGroup inline>
          <Label>Quantity:</Label>
          <Input
            min={1}
            type="number"
            value={quantity}
            onChange={onChangeQuantity}
          />
        </FormGroup>
        <Button onClick={onClick} disabled={quantity < 1} fill color="primary">
          Add to cart <Icon icon="cart-plus" />
        </Button>
        <AddToCartSuccessAdvice />
      </div>
    );
  }
  return null;
};

AddProductToCartButton.propTypes = {
  productId: PropTypes.number.isRequired,
  dealerId: PropTypes.number.isRequired,
  variantId: PropTypes.number,
  customerId: PropTypes.number.isRequired,
  createShoppingCart: PropTypes.func.isRequired,
  updateShoppingCart: PropTypes.func.isRequired,
  fetchShoppingCart: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired
};

export default fp.pipe(
  WithFetchShoppingCart,
  connect(
    state => ({
      role: state.settings.role
    }),
    {
      createShoppingCart: actions.createShoppingCart,
      updateShoppingCart: actions.updateShoppingCart
    }
  )
)(AddProductToCartButton);
